import '@mssgme/scss-basics';
import React from 'react';
import { render } from 'react-dom';

import { trans } from '@mssgme/shared';
import RedirectApp from './components/Redirect';

const data = window.INITIAL_DATA;
const { lang } = window.document.documentElement;

trans.extend(window.LOCALES);

render(<RedirectApp data={data} lang={lang} />, document.getElementById('root'));
